import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {displayPhone, formDate, handleDefaultValues} from "../common/Utils";
import {useForm} from 'react-hook-form';
import {getFamilyMemberTypes} from "../common/api/WebApi";
import MDInput from "../../components/MDInput";
import {NativeSelect} from "@mui/material";
import MDButton from "../../components/MDButton";
import dayjs from "dayjs";
import {DesktopDatePicker} from "@mui/x-date-pickers";
import Divider from "@mui/material/Divider";
import {CONSTANTS} from "../common/constants";

export default function ManageFamilyMemberModal({
                                                  familyMember,
                                                  handleCloseFamilyMember,
                                                  handleSaveFamilyMember,
                                                  show,
                                                  embedded,
                                                  saving
                                                }) {

  const [context, setContext] = useContext(AppContext);
  const [member, setMember] = useState(familyMember);
  const [emergencyContact, setEmergencyContact] = useState(familyMember?.emergencyContact);
  const [familyMemberTypes, setFamilyMemberTypes] = useState([]);
  const [typesReady, setTypesReady] = useState(false);
  const [dob, setDob] = useState();
  const [familyMemberType, setFamilyMemberType] = useState(null);

  useEffect(() => {
    if (familyMember?.dob) {
      setDob(formDate(familyMember?.dob));
    }
  }, [familyMember?.dob]);

  useEffect(()=>{
    if (familyMember) {
      setFamilyMemberType(familyMember?.familyMemberType?.id)
    }
  }, [familyMember]);

  useEffect(() => {
    let _dob = {...dob};
    try {
      let dd = new Date(dob);
      _dob = dd;
      let _member = {...member};
      _member.dob = dd;
      setMember(_member);
    } catch (err) {
      console.error(err);
    }
  }, [dob]);

  const [isNew, setIsNew] = useState(!!!familyMember?.guid);
  const [formInvalid, setFormInvalid] = useState(false);

  useEffect(() => {
    getFamilyMemberTypes().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setFamilyMemberTypes(result);
        setTypesReady(true);
      }
    });
  }, [show]);

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(member)
  });

  const handleCloseFamilyMemberFn = () => {
    handleCloseFamilyMember();
    setMember(null);
  };

  const handleSaveFamilyMemberFn = (data) => {
    handleSaveFamilyMember(data);
    setMember(null);
  };

  const toggleEmergencyContact = (e) => {
    setEmergencyContact(e.target.checked);
  };


  return (
    <Modal onHide={handleCloseFamilyMemberFn} size={'lg'} show={show}>
      <form onSubmit={handleSubmit(handleSaveFamilyMemberFn)} id={'memberForm'}>
        <Modal.Header closeButton>
          <Modal.Title>{isNew ? 'Create New' : 'Manage'} Family Member</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className={'col col-main'} xs={12}>
              <Container>
                <Row className={'my-3'}>
                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">
                      <MDInput
                        InputLabelProps={{shrink: true}}
                        placeholder={"Enter First Name"}
                        variant="outlined" type="text" required
                        {...register('firstName')}
                        className="form-control" id="firstName"
                        label="First name"/>
                    </div>
                  </Col>

                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">
                      <MDInput
                        InputLabelProps={{shrink: true}}
                        placeholder={"Enter Last Name"}
                        variant="outlined" type="text" required
                        {...register('lastName')}
                        className="form-control" id="lastName"
                        label="Last name"/>
                    </div>
                  </Col>
                </Row>


                <Row className={'my-3'}>
                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group native-margin-fix">
                      <label className={"native-label"} htmlFor="state">Family Member Type</label>
                      {typesReady && <NativeSelect
                        required
                        id={'familyMemberType'}
                        variant="outlined"
                        name={'familyMemberType'} className={'form-control'}
                        {...register('familyMemberType.id', {
                          required: true,
                          min: 1,
                          onChange:((e)=>{
                            setFamilyMemberType(parseInt(e.target.value))
                          })
                        })} >
                        {
                          familyMemberTypes.map((c) =>
                            <option value={c.id} key={c.id}>
                              {c.name}
                            </option>)
                        }
                      </NativeSelect>}
                    </div>
                  </Col>

                  <Col className={'col'} sm={4} xs={8}>

                    {familyMemberType === CONSTANTS.FAMILY_MEMBER_TYPE.CHILD && <>
                      <div className="form-group native-margin-fix">
                        <label className={"native-label"} htmlFor="dob">Birth Date</label>
                        <div className={'input-group d-block'}>
                          <DesktopDatePicker
                            maxDate={dayjs()}
                            value={dob ? dayjs(dob) : null}
                            onChange={(e) => {
                              setDob(e?.$d || null);
                            }}
                          />
                        </div>
                      </div>
                    </>
                    }

                  </Col>
                </Row>

                <Row className={'mt-2'}>
                  <Col className={'col'} sm={6} xs={6}>

                    {familyMemberType !== CONSTANTS.FAMILY_MEMBER_TYPE.CHILD &&
                      <label htmlFor="emergencyContact" className={'mt-4'}>
                        <input type="checkbox"
                               {...register('emergencyContact',
                                 {
                                   onChange: (e) => {
                                     toggleEmergencyContact(e);
                                   }
                                 })}
                               id="emergencyContact"/>
                        &nbsp;Emergency Contact
                      </label>
                    }

                  </Col>
                </Row>
                {emergencyContact &&
                  <Row className={'my-2'}>
                    <Col className={'col'} sm={6} xs={12}>
                      <div className="form-group">
                        <MDInput
                          InputLabelProps={{shrink: true}}
                          placeholder={"Enter Emergency Phone"}
                          variant="outlined" type="text"
                          {...register('phoneNumber', {
                            onChange: (e) => {
                              e.target.value = displayPhone(e.target.value);
                            }
                          })}
                          className="form-control" id="phoneNumber"
                          label="Emergency Phone"/>
                      </div>
                    </Col>
                  </Row>
                }

                <Row className={"my-3"}>
                  <Divider/>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group mt-2">
                      <MDInput
                        type="text"
                        {...register('note')}
                        autoComplete="off"
                        className="form-control" id="note"
                        InputLabelProps={{shrink: true}}
                        placeholder={"Add Note"}
                        label="Add Note"/>
                      <label><input type="checkbox"
                                    role={'switch'}
                                    {...register('pinned')}
                                    id="pinned"
                                    name="pinned"
                      />&nbsp;Pinned Note</label>
                    </div>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>

        </Modal.Body>
        <Modal.Footer>
          {embedded && <>
            <MDButton type="button" color="info" disabled={formInvalid || saving} onClick={(e)=>{
              e.preventDefault();
              handleSubmit(handleSaveFamilyMemberFn)();
            }}>
              {saving ? 'Saving...' : 'Save'}
            </MDButton>
          </>}
          {!embedded && <>
            <MDButton type="submit" color="info" disabled={formInvalid || saving}>
              {saving ? 'Saving...' : 'Save'}
            </MDButton>
          </>}
        </Modal.Footer>
      </form>
    </Modal>
  );
}